import { render, staticRenderFns } from "./ShareResourcePopup.vue?vue&type=template&id=7aca7cf3&scoped=true&"
import script from "./ShareResourcePopup.vue?vue&type=script&lang=js&"
export * from "./ShareResourcePopup.vue?vue&type=script&lang=js&"
import style0 from "./ShareResourcePopup.vue?vue&type=style&index=0&id=7aca7cf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca7cf3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aca7cf3')) {
      api.createRecord('7aca7cf3', component.options)
    } else {
      api.reload('7aca7cf3', component.options)
    }
    module.hot.accept("./ShareResourcePopup.vue?vue&type=template&id=7aca7cf3&scoped=true&", function () {
      api.rerender('7aca7cf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileExplorer/ShareResourcePopup.vue"
export default component.exports